import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  StopOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import * as APITypes from "~/API";

export const AccessRightStatusTag = ({
  status,
}: {
  status: APITypes.ResourceAccessRightStatus;
}) => {
  const { t } = useTranslation();
  let color: string;
  let icon: React.ReactNode;
  let statusText: string;

  switch (status) {
    case APITypes.ResourceAccessRightStatus.Granted: {
      color = "success";
      icon = <CheckCircleOutlined />;
      statusText = t("Granted");
      break;
    }
    case APITypes.ResourceAccessRightStatus.Requested: {
      color = "warning";
      icon = <ClockCircleOutlined />;
      statusText = t("Requested");
      break;
    }
    case APITypes.ResourceAccessRightStatus.Revoked: {
      color = "error";
      icon = <StopOutlined />;
      statusText = t("Revoked");
      break;
    }
    case APITypes.ResourceAccessRightStatus.NotGranted:
    default: {
      color = "default";
      icon = <MinusCircleOutlined />;
      statusText = t("Not_Granted");
      break;
    }
  }

  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
